function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "debateTitle"
}, "debate");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M40 23c9.389 0 17 7.611 17 17 0 9.28-7.437 16.825-16.677 16.997L40 57H23l4.44-5.545C24.682 48.434 23 44.413 23 40c0-9.387 7.609-16.998 16.996-17H40zm8.614 14.134c-1.567 0-2.837 1.27-2.837 2.838 0 1.567 1.27 2.837 2.837 2.837 1.567 0 2.838-1.27 2.838-2.837 0-1.568-1.27-2.838-2.838-2.838zm-17.025 0c-1.567 0-2.837 1.27-2.837 2.838 0 1.567 1.27 2.837 2.837 2.837 1.567 0 2.838-1.27 2.838-2.837 0-1.568-1.27-2.838-2.838-2.838zm8.513-2.497c-1.567 0-2.838 1.27-2.838 2.837 0 1.568 1.27 2.838 2.838 2.838 1.567 0 2.837-1.27 2.837-2.838 0-1.567-1.27-2.837-2.837-2.837z",
  transform: "translate(-372 -650) translate(372 650)"
}))));

var SvgPrimaryButtonUiDebateIcon = function SvgPrimaryButtonUiDebateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    "aria-labelledby": "debateTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "debateTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimaryButtonUiDebateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primary-button-ui-debate-icon.92ef8872.svg";
export { ForwardRef as ReactComponent };